<div  class="bg-white p-3 shadow-3 border-round-sm">


   <div class="rem-text-default flex align-items-center">
          <div class="rem-bg-light p-2 mr-2">
            <i class="pi pi-mobile font-medium"></i>
          </div>
          <div class="text-lg">SMS Errors</div>
        </div>
        <div class="mt-6">

          <div class="px-3 flex align-items-center gap-3 mb-8">            
            <p-floatLabel>
              <p-calendar 
                    id="fromDate"
                    [(ngModel)]="fromDate"
                    [readonlyInput]="true"      
                    [maxDate]="toDate"             
              />
              <label for="fromDate">From Date</label>
            </p-floatLabel>

            <p-floatLabel>
              <p-calendar 
                    id="fromDate"
                    [(ngModel)]="toDate"
                    [readonlyInput]="true"            
                    [minDate]="fromDate"
                    [maxDate]="todaysDate"
              />
              <label for="fromDate">To Date</label>
            </p-floatLabel>

             <p-floatLabel>
              <input 
                  [(ngModel)]="errorCode" 
                  class="w-full" 
                  pInputText   
                  id="errorCode"                  
                  />
              <label for="errorCode">Error Code</label>
            </p-floatLabel>

            <p-floatLabel>
              <p-inputNumber 
                    [(ngModel)]="recordCount"
                    class="w-full"
                    styleClass="w-full"
                    inputId="recordCount"                     
              /> 
              <label for="recordCount">Record Count</label>
            </p-floatLabel>

       
            <remitter-button
              label='Generate'
              icon='send'
              (click)="getGraph()"
            >     
            </remitter-button>
          </div>

          <div *ngIf="chartOptionsPie_SpecificErrorCode" class="flex">
            <div class="flex-1 pl-3">
                  <div class="font-bold text-blue-600 text-lg">Summary of SMS Error Code {{errorCode_Display}}</div>
                  <div class="font-bold text-700 text-sm mt-2">Top Creditors by Error Count</div>

                  <div *ngIf="isArrayWithData(table_SpecificErrorCode)">
                   <div echarts [options]="chartOptionsPie_SpecificErrorCode" class="donut-chart"></div>
                  </div>

                  <div *ngIf="!isArrayWithData(table_SpecificErrorCode)" class="flex align-items-center justify-content-center h-20rem">
                      <div class="font-bold text-red-700"><i class="pi pi-exclamation-triangle"></i> There is no data to display. Please adjust your filter.</div>
                  </div>
            </div>

            <div *ngIf="isArrayWithData(table_SpecificErrorCode)" class="flex-1">
                <div class="table">
                    <div class="table-header">
                        <div>Creditor ID</div>                    
                        <div>Count</div>
                        <div>% of Total</div>
                    </div>

                    <div
                        class="table-row"
                        *ngFor="let row of table_SpecificErrorCode"
                    >
                        <div class="creditor-cell">
                            <span
                                class="color-dot"
                                [style.background]="row.color"
                            ></span>

                            {{ row.creditorId }}
                        </div>

                        

                        <div>{{ row.count | number }}</div>

                        <div>{{ row.percent }}%</div>
                    </div>

                    <div class="table-footer">
                        <div>Total</div>                    
                        <div>{{ totalCount_SpecificCode | number }}</div>
                        <div>100.0%</div>
                    </div>
                </div>
            </div>
          </div>


          <div *ngIf="chartOptionsPie_AllErrorCodes" class="flex">
            <div class="flex-1 pl-3">
                  <div class="font-bold text-blue-600 text-lg">Summary of All SMS Error Codes</div>
                  <div class="font-bold text-700 text-sm mt-2">Errors by Error Count</div>

                  <div *ngIf="isArrayWithData(table_AllErrorCodes)">
                   <div echarts [options]="chartOptionsPie_AllErrorCodes" class="donut-chart"></div>
                  </div>

                  <div *ngIf="!isArrayWithData(table_AllErrorCodes)" class="flex align-items-center justify-content-center h-20rem">
                      <div class="font-bold text-red-700"><i class="pi pi-exclamation-triangle"></i> There is no data to display. Please adjust your filter.</div>
                  </div>
            </div>

            <div *ngIf="isArrayWithData(table_AllErrorCodes)" class="flex-1">
                <div class="table">
                                      <!-- HEADER -->
                  <div class="table-header">
                      <div>Error Code</div>

                      <div>Creditor IDs</div>

                      <div>Total Count</div>

                      <div>% of Total</div>
                  </div>

                  <!-- ROWS -->
                  <div
                      class="table-row"
                      *ngFor="let row of table_AllErrorCodes"
                  >
                      <!-- ERROR CODE -->
                      <div class="error-code-cell">
                          <span
                              class="color-dot"
                              [style.background]="row.color"
                          ></span>

                          {{ row.errorCode }}
                      </div>

                      <!-- CREDITOR IDS -->
                      <div class="creditor-badges">
                          <span
                              class="creditor-badge"
                              *ngFor="let creditorId of row.creditorIds"
                          >
                              {{ creditorId }}
                          </span>
                      </div>

                      <!-- COUNT -->
                      <div>
                          {{ row.count | number }}
                      </div>

                      <!-- PERCENT -->
                      <div>
                          {{ row.percent }}%
                      </div>
                  </div>

                  <!-- FOOTER -->
                  <div class="table-footer">
                      <div>Total</div>

                      <div>—</div>

                      <div>
                          {{ totalCount_AllErrorCodes | number }}
                      </div>

                      <div>100.0%</div>
                  </div>
                </div>
              </div>
       
          </div>

        </div>

</div>
